import type { ReactNode } from 'react'
import styles from './WhyGrowthSection.module.css'

const icons: Record<string, JSX.Element> = {
  enterprise: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15964_90331)">
        <path
          d="M14.4399 14.585L13.5312 16.9707H15.3402L14.4399 14.585Z"
          fill="black"
        />
        <path
          d="M8.8125 23.1875H23.1875V8.8125H8.8125V23.1875ZM19.5938 12.25C19.5938 11.7322 20.0135 11.3125 20.5312 11.3125C21.049 11.3125 21.4688 11.7322 21.4688 12.25V19.75C21.4688 20.2677 21.049 20.6875 20.5312 20.6875C20.0135 20.6875 19.5938 20.2677 19.5938 19.75V12.25ZM10.5926 19.4163L13.4089 12.0219C13.4116 12.0148 13.4144 12.0077 13.4172 12.0006C13.5881 11.5831 13.99 11.3129 14.4412 11.3125H14.4423C14.8931 11.3125 15.295 11.5817 15.4665 11.9986C15.47 12.0071 15.4734 12.0157 15.4766 12.0243L18.2673 19.419C18.4501 19.9034 18.2056 20.4443 17.7212 20.6271C17.6122 20.6683 17.5003 20.6877 17.3903 20.6877C17.0114 20.6877 16.6547 20.4564 16.5131 20.081L16.0469 18.8459H12.8162L12.3448 20.0836C12.1605 20.5675 11.6189 20.8104 11.1351 20.6261C10.6512 20.4418 10.4084 19.9002 10.5926 19.4163Z"
          fill="black"
        />
        <path
          d="M26.9375 4.125H5.0625C4.54475 4.125 4.125 4.54475 4.125 5.0625V26.9375C4.125 27.4552 4.54475 27.875 5.0625 27.875H26.9375C27.4552 27.875 27.875 27.4552 27.875 26.9375V5.0625C27.875 4.54475 27.4552 4.125 26.9375 4.125ZM25.0625 24.125C25.0625 24.6427 24.6427 25.0625 24.125 25.0625H7.875C7.35725 25.0625 6.9375 24.6427 6.9375 24.125V7.875C6.9375 7.35725 7.35725 6.9375 7.875 6.9375H24.125C24.6427 6.9375 25.0625 7.35725 25.0625 7.875V24.125Z"
          fill="black"
        />
        <path
          d="M26.3125 0.9375C26.3125 0.41975 25.8928 0 25.375 0C24.8572 0 24.4375 0.41975 24.4375 0.9375V2.25H26.3125V0.9375Z"
          fill="black"
        />
        <path
          d="M22.5625 0.9375C22.5625 0.41975 22.1428 0 21.625 0C21.1072 0 20.6875 0.41975 20.6875 0.9375V2.25H22.5625V0.9375Z"
          fill="black"
        />
        <path
          d="M18.8125 0.9375C18.8125 0.41975 18.3928 0 17.875 0C17.3572 0 16.9375 0.41975 16.9375 0.9375V2.25H18.8125V0.9375Z"
          fill="black"
        />
        <path
          d="M15.0625 0.9375C15.0625 0.41975 14.6428 0 14.125 0C13.6072 0 13.1875 0.41975 13.1875 0.9375V2.25H15.0625V0.9375Z"
          fill="black"
        />
        <path
          d="M11.3125 0.9375C11.3125 0.41975 10.8928 0 10.375 0C9.85725 0 9.4375 0.41975 9.4375 0.9375V2.25H11.3125V0.9375Z"
          fill="black"
        />
        <path
          d="M7.5625 0.9375C7.5625 0.41975 7.14275 0 6.625 0C6.10725 0 5.6875 0.41975 5.6875 0.9375V2.25H7.5625V0.9375Z"
          fill="black"
        />
        <path
          d="M24.4375 31.0625C24.4375 31.5803 24.8572 32 25.375 32C25.8928 32 26.3125 31.5803 26.3125 31.0625V29.75H24.4375V31.0625Z"
          fill="black"
        />
        <path
          d="M20.6875 31.0625C20.6875 31.5803 21.1072 32 21.625 32C22.1428 32 22.5625 31.5803 22.5625 31.0625V29.75H20.6875V31.0625Z"
          fill="black"
        />
        <path
          d="M16.9375 31.0625C16.9375 31.5803 17.3572 32 17.875 32C18.3928 32 18.8125 31.5803 18.8125 31.0625V29.75H16.9375V31.0625Z"
          fill="black"
        />
        <path
          d="M13.1875 31.0625C13.1875 31.5803 13.6072 32 14.125 32C14.6428 32 15.0625 31.5803 15.0625 31.0625V29.75H13.1875V31.0625Z"
          fill="black"
        />
        <path
          d="M9.4375 31.0625C9.4375 31.5803 9.85725 32 10.375 32C10.8928 32 11.3125 31.5803 11.3125 31.0625V29.75H9.4375V31.0625Z"
          fill="black"
        />
        <path
          d="M5.6875 31.0625C5.6875 31.5803 6.10725 32 6.625 32C7.14275 32 7.5625 31.5803 7.5625 31.0625V29.75H5.6875V31.0625Z"
          fill="black"
        />
        <path
          d="M0 6.625C0 7.14275 0.41975 7.5625 0.9375 7.5625H2.25V5.6875H0.9375C0.41975 5.6875 0 6.10725 0 6.625Z"
          fill="black"
        />
        <path
          d="M0 10.375C0 10.8928 0.41975 11.3125 0.9375 11.3125H2.25V9.4375H0.9375C0.41975 9.4375 0 9.85725 0 10.375Z"
          fill="black"
        />
        <path
          d="M0 14.125C0 14.6428 0.41975 15.0625 0.9375 15.0625H2.25V13.1875H0.9375C0.41975 13.1875 0 13.6072 0 14.125Z"
          fill="black"
        />
        <path
          d="M0 17.875C0 18.3928 0.41975 18.8125 0.9375 18.8125H2.25V16.9375H0.9375C0.41975 16.9375 0 17.3572 0 17.875Z"
          fill="black"
        />
        <path
          d="M0 21.625C0 22.1428 0.41975 22.5625 0.9375 22.5625H2.25V20.6875H0.9375C0.41975 20.6875 0 21.1072 0 21.625Z"
          fill="black"
        />
        <path
          d="M0 25.375C0 25.8928 0.41975 26.3125 0.9375 26.3125H2.25V24.4375H0.9375C0.41975 24.4375 0 24.8572 0 25.375Z"
          fill="black"
        />
        <path
          d="M32 6.625C32 6.10725 31.5803 5.6875 31.0625 5.6875H29.75V7.5625H31.0625C31.5803 7.5625 32 7.14275 32 6.625Z"
          fill="black"
        />
        <path
          d="M31.0625 9.4375H29.75V11.3125H31.0625C31.5803 11.3125 32 10.8928 32 10.375C32 9.85725 31.5803 9.4375 31.0625 9.4375Z"
          fill="black"
        />
        <path
          d="M31.0625 13.1875H29.75V15.0625H31.0625C31.5803 15.0625 32 14.6428 32 14.125C32 13.6072 31.5803 13.1875 31.0625 13.1875Z"
          fill="black"
        />
        <path
          d="M31.0625 16.9375H29.75V18.8125H31.0625C31.5803 18.8125 32 18.3928 32 17.875C32 17.3572 31.5803 16.9375 31.0625 16.9375Z"
          fill="black"
        />
        <path
          d="M31.0625 20.6875H29.75V22.5625H31.0625C31.5803 22.5625 32 22.1428 32 21.625C32 21.1072 31.5803 20.6875 31.0625 20.6875Z"
          fill="black"
        />
        <path
          d="M31.0625 24.4375H29.75V26.3125H31.0625C31.5803 26.3125 32 25.8928 32 25.375C32 24.8572 31.5803 24.4375 31.0625 24.4375Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_15964_90331">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  threat: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15964_90364)">
        <path
          d="M19.2812 23.5625H12.7188C12.201 23.5625 11.7812 23.9822 11.7812 24.5V31.0625C11.7812 31.5802 12.201 32 12.7188 32H19.2812C19.799 32 20.2188 31.5802 20.2188 31.0625V24.5C20.2188 23.9822 19.799 23.5625 19.2812 23.5625ZM16 28.7188C15.4822 28.7188 15.0625 28.299 15.0625 27.7812C15.0625 27.2635 15.4822 26.8438 16 26.8438C16.5177 26.8438 16.9375 27.2635 16.9375 27.7812C16.9375 28.299 16.5177 28.7188 16 28.7188Z"
          fill="black"
        />
        <path
          d="M7.5 23.5625H0.9375C0.41975 23.5625 0 23.9822 0 24.5V31.0625C0 31.5802 0.41975 32 0.9375 32H7.5C8.01775 32 8.4375 31.5802 8.4375 31.0625V24.5C8.4375 23.9822 8.01775 23.5625 7.5 23.5625ZM4.21875 28.7188C3.701 28.7188 3.28125 28.299 3.28125 27.7812C3.28125 27.2635 3.701 26.8438 4.21875 26.8438C4.7365 26.8438 5.15625 27.2635 5.15625 27.7812C5.15625 28.299 4.7365 28.7188 4.21875 28.7188Z"
          fill="black"
        />
        <path
          d="M31.0625 23.5625H24.5C23.9822 23.5625 23.5625 23.9822 23.5625 24.5V31.0625C23.5625 31.5802 23.9822 32 24.5 32H31.0625C31.5802 32 32 31.5802 32 31.0625V24.5C32 23.9822 31.5802 23.5625 31.0625 23.5625ZM27.7812 28.7188C27.2635 28.7188 26.8438 28.299 26.8438 27.7812C26.8438 27.2635 27.2635 26.8438 27.7812 26.8438C28.299 26.8438 28.7188 27.2635 28.7188 27.7812C28.7188 28.299 28.299 28.7188 27.7812 28.7188Z"
          fill="black"
        />
        <path
          d="M16 5C20.1421 5 23.5 3.88071 23.5 2.5C23.5 1.11929 20.1421 0 16 0C11.8579 0 8.5 1.11929 8.5 2.5C8.5 3.88071 11.8579 5 16 5Z"
          fill="black"
        />
        <path
          d="M10.6453 9.09027C12.1128 9.47546 14.0145 9.68765 16 9.68765C17.9855 9.68765 19.8872 9.47546 21.3547 9.09027C22.8747 8.69127 23.4117 8.23996 23.5 8.08959V5.33496C23.0464 5.60384 22.5097 5.84221 21.8962 6.04671C20.2935 6.5809 18.1996 6.87515 16 6.87515C13.8004 6.87515 11.7065 6.5809 10.1038 6.04671C9.49031 5.84227 8.95356 5.6039 8.5 5.33496V8.08959C8.58825 8.23996 9.12519 8.69127 10.6453 9.09027Z"
          fill="black"
        />
        <path
          d="M16 14.3745C20.1421 14.3745 23.5 13.2552 23.5 11.8745V10.3271C21.4751 11.2625 18.2392 11.562 16 11.562C13.7608 11.562 10.5249 11.2625 8.5 10.3271V11.8745C8.5 13.2552 11.8579 14.3745 16 14.3745Z"
          fill="black"
        />
        <path
          d="M5.15625 19.4376H15.0625V21.6876H16.9375V19.4376H26.8438V21.6876H28.7188V18.5001C28.7188 17.9824 28.299 17.5626 27.7812 17.5626H16.9375V16.2314C16.6278 16.2434 16.3152 16.2501 16 16.2501C15.6848 16.2501 15.3722 16.2434 15.0625 16.2314V17.5626H4.21875C3.701 17.5626 3.28125 17.9824 3.28125 18.5001V21.6876H5.15625V19.4376Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_15964_90364">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  soc: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15964_90376)">
        <path
          d="M29.0529 14.0586H2.94461C2.11574 14.0558 1.69386 15.0752 2.28174 15.659L13.053 26.4302V31.0627C13.053 31.3876 13.2212 31.6894 13.4976 31.8602C13.7791 32.0343 14.1246 32.0438 14.4097 31.9012L18.4264 29.8928C18.744 29.7341 18.9446 29.4095 18.9446 29.0543V26.4302L29.7159 15.659C30.3039 15.0748 29.8814 14.0557 29.0529 14.0586Z"
          fill="black"
        />
        <path
          d="M18.9468 2.94581C18.9468 1.3215 17.6252 0 16.0009 0C12.0929 0.161812 12.094 5.73044 16.0009 5.89169C17.6252 5.89169 18.9468 4.57019 18.9468 2.94581Z"
          fill="black"
        />
        <path
          d="M12.9844 11.9167H19.0094C19.5271 11.9167 19.9469 11.497 19.9469 10.9792V9.84171C19.7293 4.60021 12.2625 4.60427 12.0469 9.84171V10.9792C12.0469 11.497 12.4666 11.9167 12.9844 11.9167Z"
          fill="black"
        />
        <path
          d="M28.9858 2.94581C28.9858 1.3215 27.6643 0 26.04 0C22.1319 0.161812 22.1331 5.73044 26.04 5.89169C27.6643 5.89169 28.9858 4.57019 28.9858 2.94581Z"
          fill="black"
        />
        <path
          d="M26.0437 5.8916C23.8657 5.8916 22.0938 7.6636 22.0938 9.8416V10.9791C22.0938 11.4969 22.5135 11.9166 23.0312 11.9166H29.0562C29.574 11.9166 29.9937 11.4969 29.9937 10.9791V9.8416C29.9937 7.66354 28.2217 5.8916 26.0437 5.8916Z"
          fill="black"
        />
        <path
          d="M8.89987 2.94581C8.89987 1.3215 7.57837 0 5.95406 0C2.046 0.161812 2.04712 5.73044 5.95406 5.89169C7.57837 5.89169 8.89987 4.57019 8.89987 2.94581Z"
          fill="black"
        />
        <path
          d="M2.94531 11.9167H8.97031C9.48806 11.9167 9.90781 11.497 9.90781 10.9792V9.84171C9.69025 4.60021 2.22344 4.60427 2.00781 9.84171V10.9792C2.00781 11.497 2.4275 11.9167 2.94531 11.9167Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_15964_90376">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  fraud: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9375 5.35656L19.9876 4.30813C20.4695 4.88338 21.1926 5.25 22 5.25C23.4474 5.25 24.625 4.07244 24.625 2.625C24.625 1.17756 23.4474 0 22 0C20.5827 0 19.4249 1.12931 19.3773 2.53519L16 3.69619L12.6228 2.53525C12.5751 1.12931 11.4173 0 10 0C8.55256 0 7.375 1.17756 7.375 2.625C7.375 4.07244 8.55256 5.25 10 5.25C10.8074 5.25 11.5305 4.88338 12.0124 4.30813L15.0625 5.35656V7.93975H16.9375V5.35656Z"
        fill="black"
      />
      <path
        d="M18.5 24.4375C20.2558 24.4375 21.7084 23.1144 21.9128 21.4128C23.6144 21.2084 24.9375 19.7558 24.9375 18C24.9375 17.2784 24.7061 16.578 24.2936 16C24.7061 15.422 24.9375 14.7216 24.9375 14C24.9375 12.2442 23.6144 10.7916 21.9128 10.5872C21.7084 8.88556 20.2558 7.5625 18.5 7.5625C17.9374 7.5625 17.4065 7.699 16.9375 7.93975V17.6875H19.125C19.6427 17.6875 20.0625 18.1073 20.0625 18.625C20.0625 19.1427 19.6427 19.5625 19.125 19.5625H16.9375V24.0199H15.0625V14.3125H12.875C12.3573 14.3125 11.9375 13.8927 11.9375 13.375C11.9375 12.8573 12.3573 12.4375 12.875 12.4375H15.0625V7.93975C14.5935 7.699 14.0626 7.5625 13.5 7.5625C11.7442 7.5625 10.2916 8.88556 10.0872 10.5872C8.38556 10.7916 7.0625 12.2442 7.0625 14C7.0625 14.7216 7.29394 15.422 7.70638 16C7.29394 16.578 7.0625 17.2784 7.0625 18C7.0625 19.7558 8.38556 21.2084 10.0872 21.4128C10.2916 23.1144 11.7442 24.4375 13.5 24.4375C14.0626 24.4375 14.5935 24.301 15.0625 24.0602V26.6434L12.0124 27.6919C11.5305 27.1166 10.8074 26.75 10 26.75C8.55256 26.75 7.375 27.9276 7.375 29.375C7.375 30.8224 8.55256 32 10 32C11.4173 32 12.5751 30.8707 12.6228 29.4648L16 28.3038L19.3773 29.4648C19.4249 30.8707 20.5827 32 22 32C23.4474 32 24.625 30.8224 24.625 29.375C24.625 27.9276 23.4474 26.75 22 26.75C21.1926 26.75 20.4695 27.1166 19.9876 27.6919L16.9375 26.6434V24.0602C17.4065 24.301 17.9374 24.4375 18.5 24.4375Z"
        fill="black"
      />
    </svg>
  ),
  cloud: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15964_90395)">
        <path
          d="M14.7032 18.2307C14.943 18.2307 15.183 18.1392 15.366 17.9561L26.4971 6.82575V10.3999C26.4971 10.9177 26.9168 11.3374 27.4346 11.3374C27.9523 11.3374 28.3721 10.9177 28.3721 10.3999V4.5625C28.3721 4.04475 27.9523 3.625 27.4346 3.625H21.5968C21.0791 3.625 20.6593 4.04475 20.6593 4.5625C20.6593 5.08025 21.0791 5.5 21.5968 5.5H25.1712L14.0402 16.6302C13.6741 16.9964 13.6741 17.5899 14.0402 17.9561C14.2233 18.1391 14.4632 18.2307 14.7032 18.2307Z"
          fill="black"
        />
        <path
          d="M12.8111 24.6574V20.1279C12.8111 19.6102 12.3913 19.1904 11.8736 19.1904H7.34375V24.6574H12.8111Z"
          fill="black"
        />
        <path
          d="M5.46737 25.5949V19.1904H0.9375C0.41975 19.1904 0 19.6102 0 20.1279V31.0619C0 31.5796 0.41975 31.9994 0.9375 31.9994H11.8722C12.3899 31.9994 12.8097 31.5796 12.8097 31.0619V26.5324H6.40487C5.88706 26.5324 5.46737 26.1127 5.46737 25.5949Z"
          fill="black"
        />
        <path
          d="M31.0639 0.000976562H6.40625C5.8885 0.000976562 5.46875 0.420727 5.46875 0.938477V19.1901H7.34375V1.87598H30.1264V24.6571H12.8111V26.5321H31.0639C31.5816 26.5321 32.0014 26.1124 32.0014 25.5946V0.938477C32.0014 0.420727 31.5816 0.000976562 31.0639 0.000976562Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_15964_90395">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  cyberphysical: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15964_90403)">
        <path
          d="M15.8278 19.5854C17.8168 19.5854 19.4291 17.973 19.4291 15.9841C19.4291 13.9952 17.8168 12.3828 15.8278 12.3828C13.8389 12.3828 12.2266 13.9952 12.2266 15.9841C12.2266 17.973 13.8389 19.5854 15.8278 19.5854Z"
          fill="black"
        />
        <path
          d="M25.3863 11.707H25.3854C24.2209 11.707 23.2758 12.6521 23.2758 13.8175V15.8895C23.2758 19.9723 19.9649 23.2841 15.8812 23.2841C11.7971 23.2841 8.48565 19.9722 8.48565 15.8895V13.8175C8.48565 12.6512 7.53959 11.707 6.37521 11.707C5.21071 11.707 4.26562 12.6521 4.26562 13.8175V15.851C4.26562 19.638 6.07806 23.0015 8.88242 25.1217C9.04497 25.2446 9.14048 25.4365 9.14048 25.6403V31.3489C9.14048 31.7086 9.43216 32.0004 9.79199 32.0004H21.8504C22.2102 32.0004 22.5019 31.7086 22.5019 31.3489V25.6983C22.5019 25.4932 22.5985 25.3003 22.7629 25.1775C25.6373 23.0312 27.4959 19.5802 27.4959 15.7255V13.8175C27.4958 12.6521 26.5508 11.707 25.3863 11.707Z"
          fill="black"
        />
        <path
          d="M12.4585 6.082C12.5703 6.21784 12.6272 6.39056 12.6182 6.56627L12.4959 8.92682C12.4693 9.43962 12.9825 9.80766 13.4596 9.61801L15.6227 8.75828C15.7898 8.69182 15.976 8.69182 16.1431 8.75828L18.3062 9.61801C18.7833 9.80766 19.2965 9.43962 19.2699 8.92682L19.1476 6.56627C19.1385 6.39056 19.1955 6.21784 19.3073 6.082L20.7687 4.3069C21.0921 3.91411 20.9052 3.3185 20.4154 3.18083L18.1449 2.54287C17.9817 2.49701 17.8405 2.39387 17.7472 2.25237L16.471 0.316731C16.1927 -0.105577 15.5731 -0.105577 15.2946 0.316731L14.0185 2.25243C13.9252 2.39394 13.784 2.49707 13.6208 2.54294L11.3503 3.1809C10.8604 3.3185 10.6736 3.91411 10.997 4.30697L12.4585 6.082Z"
          fill="black"
        />
        <path
          d="M9.38916 8.42232C9.77082 8.04073 9.77082 7.42193 9.38916 7.04027L5.51985 3.17096C5.13826 2.78937 4.51946 2.78937 4.1378 3.17096C3.75615 3.55255 3.75615 4.17135 4.1378 4.553L8.00712 8.42232C8.38877 8.80397 9.00751 8.80391 9.38916 8.42232Z"
          fill="black"
        />
        <path
          d="M27.8657 3.17096C27.4841 2.78937 26.8653 2.78937 26.4837 3.17096L22.6144 7.04027C22.2327 7.42186 22.2327 8.04067 22.6144 8.42232C22.996 8.80397 23.6148 8.80397 23.9964 8.42232L27.8657 4.553C28.2474 4.17142 28.2474 3.55261 27.8657 3.17096Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_15964_90403">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  integration: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0034 9.90332C12.6414 9.90332 9.90625 12.6384 9.90625 16.0002C9.90625 19.3623 12.6414 22.0974 16.0034 22.0974C19.3652 22.0974 22.1003 19.3623 22.1003 16.0002C22.1003 12.6384 19.3652 9.90332 16.0034 9.90332ZM19.6233 14.852L15.2554 19.2199C15.072 19.4033 14.8315 19.4951 14.5913 19.4951C14.3511 19.4951 14.1108 19.4035 13.9275 19.2199L12.2583 17.5508C11.8916 17.1843 11.8916 16.5898 12.2583 16.2231C12.6247 15.8564 13.2192 15.8564 13.5859 16.2231L14.5913 17.2285L18.2956 13.5244C18.6621 13.1577 19.2566 13.1577 19.6233 13.5244C19.99 13.8909 19.99 14.4853 19.6233 14.852Z"
        fill="black"
      />
      <path
        d="M29.5929 8.68241L29.592 8.65751C29.578 8.35013 29.5688 8.02494 29.5631 7.66313C29.537 5.89873 28.1344 4.43926 26.3698 4.34062C22.6906 4.1353 19.8444 2.9356 17.4125 0.565245L17.3918 0.54547C16.5986 -0.181823 15.4021 -0.181823 14.6086 0.54547L14.5878 0.565245C12.156 2.9356 9.30978 4.1353 5.63059 4.34087C3.8662 4.43926 2.46337 5.89873 2.43724 7.66337C2.43187 8.02274 2.42235 8.34794 2.40844 8.65751L2.40697 8.71537C2.33544 12.4671 2.24657 17.1362 3.80858 21.3743C4.66746 23.7048 5.96824 25.7307 7.67453 27.396C9.61789 29.2925 12.1633 30.7981 15.2399 31.8708C15.34 31.9057 15.444 31.9341 15.55 31.9553C15.6994 31.9851 15.8498 32 16.0002 32C16.1506 32 16.3012 31.9851 16.4504 31.9553C16.5563 31.9341 16.6611 31.9055 16.7617 31.8703C19.8347 30.7956 22.3774 29.2893 24.319 27.3931C26.0246 25.7273 27.3254 23.7009 28.185 21.3699C29.7528 17.1192 29.6642 12.4412 29.5929 8.68241ZM15.9997 23.9753C11.6023 23.9753 8.02488 20.398 8.02488 16.0005C8.02488 11.6031 11.6023 8.02567 15.9997 8.02567C20.3969 8.02567 23.9745 11.6031 23.9745 16.0005C23.9745 20.398 20.3969 23.9753 15.9997 23.9753Z"
        fill="black"
      />
    </svg>
  ),
  growth: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.9956 5.16211H20.8025C20.2481 5.16211 19.7981 5.61148 19.7981 6.16648V8.19523C19.7981 8.74961 20.2481 9.19961 20.8025 9.19961H25.1081L16.2981 18.009L12.5631 14.274C11.7744 13.4859 10.4963 13.4859 9.7075 14.274L0.294375 23.6884C-0.098125 24.0802 -0.098125 24.7165 0.294375 25.1084L1.72875 26.5434C2.12063 26.9352 2.75688 26.9352 3.14875 26.5434L11.1356 18.5565L14.87 22.2915C15.6587 23.0804 16.937 23.0807 17.7256 22.2915L27.9625 12.0546V16.3602C27.9625 16.9146 28.4119 17.3646 28.9669 17.3646H30.9956C31.5506 17.3646 32 16.9146 32 16.3602V6.16648C32 5.61148 31.5506 5.16211 30.9956 5.16211Z"
        fill="black"
      />
    </svg>
  ),
}

type WhyGrowthSectionItem = {
  iconKey: string
  title: string
}

type WhyGrowthSectionData = {
  title: string
  subtitle: ReactNode
  items: WhyGrowthSectionItem[]
}

type WhyGrowthSectionProps = {
  data: WhyGrowthSectionData
}

const WhyGrowthSection = ({ data }: WhyGrowthSectionProps) => {
  const { title, subtitle, items } = data

  return (
    <section className={styles.whyChooseSection}>
      <div className="container">
        <h2 className={styles.sectionTitle}>{title}</h2>
        <p className={styles.sectionSubtitle}>{subtitle}</p>
        <div className="row g-3 justify-content-center">
          {items.map((item) => (
            <div key={item.iconKey} className="col-12 col-md-6 col-lg-3">
              <div className={styles.card}>
                <div className={styles.iconCircle}>{icons[item.iconKey]}</div>
                <h3 className={styles.cardTitle}>{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyGrowthSection
